import axios from "axios";

// const
const ALGORITHM_CATEGORY_UPDATE_DATA = "algorithmCategory/ALGORITHM_CATEGORY_UPDATE_DATA";
const ALGORITHM_CATEGORY_STORE_ALGORITHM_CATEGORIES = "algorithmCategory/ALGORITHM_CATEGORY_STORE_ALGORITHM_CATEGORIES";
const ALGORITHM_CATEGORY_TOGGLE_MODAL = "algorithmCategory/ALGORITHM_CATEGORY_TOGGLE_MODAL";
const ALGORITHM_CATEGORY_TOGGLE_LOADING = "algorithmCategory/ALGORITHM_CATEGORY_TOGGLE_LOADING";

const ALGORITHM_CATEGORY_MODAL_SUCCESS_TITLE = "scenes_Algorithm_AlgorithmCategory_modal_success_title";
const ALGORITHM_CATEGORY_MODAL_FAIL_TITLE = "scenes_Algorithm_AlgorithmCategory_modal_fail_title";
const ALGORITHM_CATEGORY_MODAL_SAVE_SUCCESS_CONTENT = "scenes_Algorithm_AlgorithmCategory_modal_saveSuccess_content";
const ALGORITHM_CATEGORY_MODAL_SAVE_FAIL_CONTENT = "scenes_Algorithm_AlgorithmCategory_modal_saveFail_content";
const ALGORITHM_CATEGORY_MODAL_DELETE_SUCCESS_CONTENT = "scenes_Algorithm_AlgorithmCategory_modal_deleteSuccess_content";
const ALGORITHM_CATEGORY_MODAL_DELETE_FAIL_CONTENT = "scenes_Algorithm_AlgorithmCategory_modal_deleteFail_content";
const ALGORITHM_CATEGORY_MODAL_OK_LABEL = "scenes_Algorithm_AlgorithmCategory_modal_OK_label";
const ALGORITHM_CATEGORY_MODAL_CANCEL_LABEL = "scenes_Algorithm_AlgorithmCategory_modal_cancel_label";

// reducer
export const algorithmCategory = (state = {

  loading: false,
  index: 1,
  expandedKeys: [],

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  categoryId: "",
  name: "",
  remark: "",
  initAlgorithmCategories: [],
  algorithmCategories: [],
}, action) => {
  switch (action.type) {
    case ALGORITHM_CATEGORY_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case ALGORITHM_CATEGORY_STORE_ALGORITHM_CATEGORIES:{
      const expandedKeys = [];
      const loopKeys = (data) => {
        data.map((item) => {
          if (item.children && item.children.length) {
            loopKeys(item.children);
          }
          expandedKeys.push(item.key);
        });
      };
      loopKeys(action.data);
      return {
        ...state,
        algorithmCategories: action.data,
        initAlgorithmCategories: action.data,
        expandedKeys: expandedKeys
      };
    }
    case ALGORITHM_CATEGORY_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case ALGORITHM_CATEGORY_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based on user input
 */
export const updateAlgorithmCategoryData = (data) => {
  return {
    type: ALGORITHM_CATEGORY_UPDATE_DATA,
    data: data
  }
};

/**
 * get all algorithm categories
 */
export const getAlgorithmCategories = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-algorithm/getAlgorithmCategoryTree", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeAlgorithmCategories(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all algorithm categories
 */
export const storeAlgorithmCategories = (algorithmCategories) => {
  return {
    type: ALGORITHM_CATEGORY_STORE_ALGORITHM_CATEGORIES,
    data: algorithmCategories
  }
};

/**
 * submit data
 */
export const submitAlgorithmCategory = (data) => (dispatch) => {

  dispatch(toggleLoading(true));

  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  // let body = {};
  // body.algorithmCategories = data.algorithmCategories;
  return fetch(`/api-algorithm/updateAlgorithmCategory`,
    {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data.algorithmCategories),
      credentials: "include"
    }
  ).then(
    response => {
      if (response.ok) {
        console.log("success update algorithmCategory");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_CATEGORY_MODAL_SUCCESS_TITLE,
          modalContent: ALGORITHM_CATEGORY_MODAL_SAVE_SUCCESS_CONTENT,
          modalOk: ALGORITHM_CATEGORY_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_CATEGORY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(getAlgorithmCategories());
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(getAlgorithmCategories());
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      } else {
        console.log("fail to update new algorithmCategory");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_CATEGORY_MODAL_FAIL_TITLE,
          modalContent: ALGORITHM_CATEGORY_MODAL_SAVE_FAIL_CONTENT,
          modalOk: ALGORITHM_CATEGORY_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_CATEGORY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
      dispatch(toggleLoading(false));
    }
  )
};

const loop = (data, key, callback) => {
  data.forEach((item, index, arr) => {
    if (item.key === key) {
      return callback(item, index, arr);
    }
    if (item.children) {
      return loop(item.children, key, callback);
    }
  });
};

/**
 * delete data
 */
export const deleteAlgorithmCategory = (data) => (dispatch) => {

  dispatch(toggleLoading(true));

  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  return fetch(`/api-algorithm/deleteAlgorithmCategory/` + data.categoryId,
    {
      method: "POST",
      headers: headers,
      credentials: "include"
    }
  ).then(
    response => {
      if (response.ok) {
        console.log("success delete algorithmCategory");
        const d = data.algorithmCategories;
        loop(d, data.categoryId, (item, index, arr) => {
            arr.splice(index, 1);
            dispatch(updateAlgorithmCategoryData({
              name: "algorithmCategories",
              value: d
            }));
            dispatch(updateAlgorithmCategoryData({
              name: "categoryId",
              value: ""
            }));
          }
        );
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_CATEGORY_MODAL_SUCCESS_TITLE,
          modalContent: ALGORITHM_CATEGORY_MODAL_DELETE_SUCCESS_CONTENT,
          modalOk: ALGORITHM_CATEGORY_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_CATEGORY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      } else {
        console.log("fail to delete new algorithmCategory");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_CATEGORY_MODAL_FAIL_TITLE,
          modalContent: ALGORITHM_CATEGORY_MODAL_DELETE_FAIL_CONTENT,
          modalOk: ALGORITHM_CATEGORY_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_CATEGORY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
      dispatch(toggleLoading(false));
    }
  )
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: ALGORITHM_CATEGORY_TOGGLE_MODAL,
    data: show
  }
};
/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: ALGORITHM_CATEGORY_TOGGLE_LOADING,
    data: show
  }
};
